import { animate } from "framer-motion";
import { clamp } from "lodash-es";
import { useCallback } from "react";
const animationDefaults = {
    type: "spring",
    bounce: 0.2,
};
/**
 * Obtain a function for smooth window scrolling, based on framer motion.
 * Comes with reasonable defaults, but can be fine-tuned for your needs.
 *
 * @example
 * ```
 * const scrollFn = useSmoothWindowScroll({
 *   animationOptions: {
 *     duration: 1.5,
 *   },
 *   defaultOffset: headerHeight + 20,
 * });
 *
 * const onClick = (event) => scrollFn(event.target)
 * ```
 */
export const useSmoothWindowScroll = (config) => {
    const defaultOffset = config?.defaultOffset || 100;
    const animationSettings = config?.animationOptions || animationDefaults;
    return useCallback((target, offset) => {
        const targetHeight = typeof target === "number"
            ? target
            : window.scrollY + target.getBoundingClientRect().top;
        const offsetToUse = offset !== undefined ? offset : defaultOffset;
        const targetValue = clamp(targetHeight - offsetToUse, 0, Infinity);
        animate(window.scrollY, targetValue, {
            ...animationSettings,
            onUpdate: (v) => {
                window.scroll(0, v);
            },
        });
    }, [animationSettings, defaultOffset]);
};
//# sourceMappingURL=useSmoothWindowScroll.js.map